export const AUTH_GOOGLE_ACTION = 'AUTH_GOOGLE_ACTION';
export const AUTH_GOOGLE_WITH_CODE_ACTION = 'AUTH_GOOGLE_WITH_CODE_ACTION';
export const AUTH_ERROR_ACTION = 'AUTH_ERROR_ACTION';
export const NOTIFIED_ACTION = 'NOTIFIED_ACTION';
